import { filterBy } from '@progress/kendo-data-query';
import {
  DropDownList,
  DropDownListChangeEvent,
  DropDownListFilterChangeEvent,
  DropDownsPopupSettings,
} from '@progress/kendo-react-dropdowns';
import { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { DropDownListData } from 'src/types/generic';

interface DropDownProps {
  value?: string;
  defaultValue?: string;
  options: DropDownListData;
  onChange?: (event: DropDownListChangeEvent) => void;
  valid?: boolean;
  popupSettings?: DropDownsPopupSettings;
  filterable?: boolean;
  disabled?: boolean;
}

const DropDown: FC<DropDownProps> = ({
  value,
  options,
  onChange,
  defaultValue,
  valid = true,
  popupSettings,
  filterable = true,
  disabled = false,
}) => {
  const [filterableOptions, setFilterableOptions] = useState<DropDownListData>([]);

  useEffect(() => {
    setFilterableOptions(options);
  }, [options]);

  const handleFilterChange = useCallback(
    (event: DropDownListFilterChangeEvent) => {
      setFilterableOptions(filterBy(options, event.filter));
    },
    [options]
  );

  const _value = useMemo(() => options?.find((item) => item.value === value), [options, value]);
  const _defaultValue = useMemo(
    () => options?.find((item) => item.value === defaultValue),
    [defaultValue, options]
  );

  return (
    <DropDownList
      onChange={onChange}
      value={_value ?? {}}
      defaultValue={_defaultValue}
      data={filterableOptions}
      onFilterChange={handleFilterChange}
      textField="label"
      filterable={filterable}
      valid={valid}
      popupSettings={popupSettings}
      size="small"
      disabled={disabled}
    />
  );
};

export default DropDown;
